import * as React from "react";
import { useParams } from "react-router-dom";
import { DateTime } from "luxon";
import { toast } from "react-toastify";

import { useModal } from "components/UI/Modal/ModalProvider";
import Table from "components/UI/Table";
import DeviceServiceManagementModal from "./DeviceServiceManagementModal";
import MessageModal from "components/UI/Message/MessageModal";
import { ServiceType, ServiceResponseType } from "types/ServiceType";
import {
  getDevicesServicesService,
  removeServiceFromDeviceService,
} from "services/DeviceService";

interface DeviceServiceListProps {}

export const DeviceServiceList: React.FC<DeviceServiceListProps> = () => {
  const params = useParams();
  const messageModal = useModal(MessageModal);
  const [limit, setLimit] = React.useState<number>(25);
  const deviceServiceManagementModal = useModal(DeviceServiceManagementModal);
  const [uiTimestamp, SetUiTimestamp] = React.useState<string>(
    DateTime.now().toISO()
  );

  const onNewDeviceServiceHandler = async () => {
    const res = await deviceServiceManagementModal({ ...params });

    if (res?.data) {
      toast.success(res?.data);
      SetUiTimestamp(DateTime.now().toISO());
    }
  };

  const onRemoveDeviceServiceHandler = async (service: ServiceType) => {
    const res = await messageModal({
      message: `Remover servicio ${service.name} del dispositivo?`,
      confirm: true,
    });
    if (res?.data) {
      const res2: any = await removeServiceFromDeviceService({
        deviceUUID: params.deviceUUID,
        serviceUUID: service.uuid,
      });

      if (res2?.data) {
        toast.success(res2?.data);
        SetUiTimestamp(DateTime.now().toISO());
      } else if (res2?.error) {
        toast.error(res2.error);
      }
    }
  };

  return (
    <div key={uiTimestamp} className="h-full w-full">
      <Table
        title={`Lista de servicios en dispositivo`}
        limit={limit}
        columns={[
          { title: "Nombre", field: "name" },
          { title: "Tipo", field: "type" },
        ]}
        data={async (query) => {
          const res = (await getDevicesServicesService({
            input: {
              uuid: params.deviceUUID,
              page: query.page + 1,
              query: query.search,
            },
          })) as ServiceResponseType;
          setLimit(res.totalDocs > res.limit ? res.limit : res.totalDocs);

          return {
            data: res.docs,
            page: res.page - 1,
            totalCount: res.totalDocs,
          };
        }}
        actions={[
          {
            icon: "delete",
            tooltip: "Eliminar servicio",
            onClick: (_, rowData: ServiceType) =>
              onRemoveDeviceServiceHandler(rowData),
          },
          {
            icon: "add",
            tooltip: "Agregar servicio",
            isFreeAction: true,
            onClick: onNewDeviceServiceHandler,
          },
        ]}
      />
    </div>
  );
};

export default DeviceServiceList;
